// extracted by mini-css-extract-plugin
export var sliderRange = "_r7-2";
export var sliderRoot = "_r7-0";
export var sliderThumb = "_r7-3";
export var sliderTrack = "_r7-1";